import type { NormalizeOAS, OASOutput, OASRequestParams } from 'fets';
import type { ApiClient } from '../fetsClient';
import type openapi from '../openapi';

type O = NormalizeOAS<typeof openapi>;
type RequestParams = OASRequestParams<O, '/api/project-tags', 'post'>;
type ResponseBody = OASOutput<O, '/api/project-tags', 'post'>;

type Params = {
  tagGuid: string;
  projectGuid: string;
  assign: boolean;
};

type Result = Params;

export const assignTagFactory = (apiClient: ApiClient) => {
  const assignTag = async (variables: Params): Promise<Result> => {
    const requestBody = mapInputToRequestBody(variables);
    const response = await apiClient['/api/project-tags'].post(requestBody);
    const responseBody = await response.json();

    return mapResponseToResult(responseBody, variables);
  };

  const mapInputToRequestBody = (input: Params): RequestParams => {
    return {
      json: {
        tagGuid: input.tagGuid,
        projectGuid: input.projectGuid,
        assign: input.assign,
      },
    };
  };

  const mapResponseToResult = (_response: ResponseBody, input: Params): Result => {
    return input;
  };

  return assignTag;
};
